import { render, staticRenderFns } from "./QuillTextareaGroup.vue?vue&type=template&id=aef5d834"
import script from "./QuillTextareaGroup.vue?vue&type=script&lang=js"
export * from "./QuillTextareaGroup.vue?vue&type=script&lang=js"
import style0 from "./QuillTextareaGroup.vue?vue&type=style&index=0&id=aef5d834&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports